module.exports = __webpack_public_path__ + "static/media/logo.31ef9290.png";